import React, { useState } from 'react';
import { Avatar, Box, ButtonBase, Menu, MenuItem, Typography } from '@mui/material';
import THEME from '../utils/theme';
import { useSelector } from 'react-redux';
import { useAppAliasIntlFormatter } from '@/app/hooks/formatFeatureName';

const UserAvatarMenu = () => {
  const FormattedMessage = useAppAliasIntlFormatter();
  const { user, shop } = useSelector(state => state.auth);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const gotoFuncrowd = () => window.location.replace(`/shop/${user.seqId}/home`);

  return (
    <Box>
      <ButtonBase
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          paddingX: 1.5,
          paddingY: 0.5,
          borderRadius: 2,
          '&:hover': { backgroundColor: 'rgba(0,0,0,0.06)' }
        }}
      >
        <Box sx={{ textAlign: 'right', marginRight: 1 }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '0.95rem', color: THEME.primary }}>{`${user?.firstName ||
            ''} ${user?.lastName || ''}`}</Typography>
          <Typography sx={{ fontSize: '0.75rem', opacity: 0.8, color: THEME.primary }}>{user?.type}</Typography>
        </Box>

        <Avatar src={user?.lineProfile?.pictureUrl} sx={{ width: 36, height: 36 }} />
      </ButtonBase>

      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={gotoFuncrowd}>{FormattedMessage({ id: 'mini.pos.appbar.back.to.funcrowd' })}</MenuItem>
      </Menu>
    </Box>
  );
};

export default UserAvatarMenu;
